module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD9QTFRFAAAA1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXVXolgRAAAABV0Uk5TAAFax/f/xlKF/eiGbVkn6oejkqJROoKSyAAAAGZJREFUeJzt1TEWgCAQQ8EsbIQFBUXvf1afFwBKC349dQKI88puugUBJFqffVkUOGPKe7ecaAc8U8GgUrlBeY4ccFFB7mPYyAUXXHDBf0NlHsNv9qaHNBjr3brdlRbmx37mPvwjeAHfDg4fBRSddAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_select_default.png
// module id = pxDl
// module chunks = 37